<template>
  <div class="dlrVRBottomMenu-pop">
    <div class="dlrVRBottomMenu-pop-bg">
      <a @click.stop="hide" class="dlrVRBottomMenu-pop-close"></a>
      <div class="dlrVRBottomMenu-pop-box">
        <div class="testPop">
          <div v-if="testIsClick" class="testPop-tips">
            <p>试驾邀请已发送，等待客户提交</p>
          </div>
          <div v-else class="testPop-tips">
            <p>本次带看还未向客户发起试驾邀请，快去试试吧</p>
          </div>
          <div class="testPop-btn">
            <a
              v-stat:click="{
                action: 'ZNZT-vrdk-app_subject_003',
                extend: { channelId },
              }"
              v-stat:show="{
                action: 'ZNZT-vrdk-app_subject_003_show',
                extend: { channelId },
              }"
              href="javascript:void(0);"
              @click="send"
            >
              <span>发送邀请</span>
            </a>
            </div>
        </div>
      </div>
    </div>
    <div class="dlrVRBottomMenu-pop-mask"></div>
  </div>
</template>
<script>
import layerManager from '@/services/layer.manager';
import { mapGetters } from 'vuex';
export default {
  props: {
    testIsClick: {
      type: Boolean,
      default: false
    },
    saleCarInfo: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
    computed: {
    ...mapGetters({
      vrSalesInfo: 'sales/vrSalesInfo',
    }),
    channelId () {
      return this.vrSalesInfo.channelId;
    }
  },
  methods: {
    hide () {
      this.$emit('hide')
    },
    send () {
      layerManager.price(this.saleCarInfo.seriesId, this.saleCarInfo.specId, 'bottomprice', 1);
      this.$emit('send')
      this.hide();
    }
  },
}
</script>
